module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.00171 0.87793C3.61929 0.87793 0.876709 3.62051 0.876709 7.00293C0.876709 10.3854 3.61929 13.1279 7.00171 13.1279C10.3841 13.1279 13.1267 10.3854 13.1267 7.00293C13.1267 3.62051 10.3841 0.87793 7.00171 0.87793ZM9.26304 9.32988L8.36069 9.32578L7.00171 7.70566L5.64409 9.32441L4.74038 9.32852C4.68022 9.32852 4.63101 9.28066 4.63101 9.21914C4.63101 9.19316 4.64058 9.16856 4.65698 9.14805L6.43569 7.02891L4.65698 4.91113C4.64046 4.8911 4.6313 4.86601 4.63101 4.84004C4.63101 4.77988 4.68022 4.73066 4.74038 4.73066L5.64409 4.73477L7.00171 6.35488L8.35933 4.73613L9.26167 4.73203C9.32183 4.73203 9.37105 4.77988 9.37105 4.84141C9.37105 4.86738 9.36147 4.89199 9.34507 4.9125L7.56909 7.03027L9.34644 9.14941C9.36284 9.16992 9.37241 9.19453 9.37241 9.22051C9.37241 9.28066 9.32319 9.32988 9.26304 9.32988Z",
      "fill": "black",
      "fill-opacity": "0.25"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-489b6de7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-489b6de7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/CloseFill.vue
// module id = 1491
// module chunks = 159